/* eslint-disable */
import api from './api';
import { CPB_URL } from './servers';

export const actas = (data) => api.post(`${CPB_URL}/monitoreos/getMonitoreos`, data);
export const catalogos = (data) => api.post(`${CPB_URL}/catalogos/getCatalogos`, data);
export const fetchCatalogsFromSP = (data) => api.post(`${CPB_URL}/usuarios/getCatalogsForm`, data);
export const updateActa = (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);
export const updateHallazgo = (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);
export const imagenes = (data) => api.post(`${CPB_URL}/monitoreos/getArchivosActa`, data);
export const imagenesHallazgo = (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosHallazgo`, data);
export const sincronizarActa = (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);
export const firmantesInternet = (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosMonitoreo`, data);
export const idInes = (data) => api.post(`${CPB_URL}/hallazgos/getIdINEPorEstado`, data);
export const idIneEspesifico = (data) => api.post(`${CPB_URL}//hallazgos/buscarPorIdINE`, data);